import { PureComponent } from "react";

interface IProps {
  children: any;
}

export default class TooltipErrorBoundary extends PureComponent<IProps> {
  public componentDidCatch() {
    console.warn(
      "Caught an error in the TooltipErrorBoundary. This may be expected.\n" +
        "See the code for the TooltipErrorBoundary component for more info."
    );
    // This is expected from time to time due to an issue with Reactstrap tooltips being
    // rendered inside the fixed-data-table grid - they don't play nicely with virtual
    // scrolling as the tooltips can get out of sync with the actual elements rendered
    // to the DOM.
  }

  public render() {
    const { children } = this.props;
    return children;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/TooltipErrorBoundary.tsx